<header id="header" class="header" [ngClass]="isLogged() ? 'header-logged': ' header-not-logged'">
    <div class="container-fluid d-flex align-items-center justify-content-between header-container">
        <div class="container-fluid d-flex align-items-center animate__animated animate__fadeInRight">

            <a href="#" target="_blank" class="logo"><img src="{{Etiquetas.HeaderImage3}}" alt="" class="img-fluid"></a>

            <p class="titulo-app">Order2Go</p>
        </div>
        <button [matMenuTriggerFor]="menuUsuario" *ngIf="isLogged() && !isNewUser()" mat-button
            class="animate__animated animate__fadeInRight">
            <mat-icon>account_circle</mat-icon>
            {{logged?.nombre}}
            {{logged?.apellido}}
            ({{logged?.rol}})
        </button>

        <mat-menu #menuUsuario="matMenu">
            <button (click)="cambioClave()" mat-menu-item>
                <mat-icon>key</mat-icon>
                {{Etiquetas.CambiarClave}}
            </button>
            <button (click)="logOut()" mat-menu-item>
                <mat-icon>logout</mat-icon>
                {{Etiquetas.CerrarSesion}}
            </button>

        </mat-menu>






        <!-- <div *ngIf="isLogged() && !isNewUser()"
            class="container d-flex align-items-baseline justify-content-end animate__animated animate__fadeInRight"
            style="color: white;">

            <button (click)="toggleRightSidenav();" mat-icon-button matTooltip="Menú Principal" aria-label="">
                <mat-icon class="mat-icon-menu-principal">account_circle</mat-icon>
            </button>
            <p class="nombre-usuario">
                {{logged?.nombre}}
                {{logged?.apellido}}
                ({{logged?.rol}})</p>

        </div> -->

    </div>

</header>